import gql from 'graphql-tag'
import client from '../../stores/apollo'
import normalize from './normalize'
import { FloorMapPinFragment } from '../fragments'
import { IFloorMapPin, FloorMapPins } from '../types'

interface IPayload {
  data: {
    map: {
      mapObjects: {
        pin: IFloorMapPin[]
      }
    }
  }
}

export default function pins(id: string): Promise<FloorMapPins> {
  const variables = { id }

  return client.gql.query({ query, variables }).then(
    ({
      data: {
        map: {
          mapObjects: { pin },
        },
      },
    }: IPayload) => normalize(pin)
  )
}

const query = gql`
  query Pins($id: ID!) {
    map: node(id: $id) {
      ... on Floor {
        mapObjects {
          pin {
            ...FloorMapPinFragment
          }
        }
      }
    }
  }
  ${FloorMapPinFragment}
`
